import { useMemo } from 'react';
import classnames from 'classnames';
import { ExclamationTriangleAshIcon, ExclamationCircleAshIcon } from '@glu/icons-react';
import { darkModeAware } from '@glu/theming';
import '../themeDefaults';
import useStyles from './Error.styles';

export interface IErrorProps {
  /** The error text to be displayed */
  error?: string;
  /** dark mode boolean */
  dark?: boolean;
  /** form field id */
  htmlId?: string;
  /** Sets the styles for display in a checkbox radio element */
  inCheckboxRadio?: boolean;
  /** Sets the styles for display with a warning */
  warning?: boolean;
}

const Error = ({ dark, error, htmlId, inCheckboxRadio, warning }: IErrorProps) => {
  const classes = useStyles();
  const icon = useMemo(() => {
    if (inCheckboxRadio) {
      return null;
    }
    if (error && warning) {
      return <ExclamationCircleAshIcon />;
    }
    return <ExclamationTriangleAshIcon />;
  }, [error, inCheckboxRadio, warning]);

  if (!error) {
    return null;
  }

  return (
    <div
      className={classnames(classes.wrap, {
        [classes.dark]: dark,
        [classes.warning]: warning,
        [classes.inCheckboxRadio]: inCheckboxRadio,
      })}
    >
      {icon}
      <p aria-live="polite" className={classes.root} id={htmlId} role="region">
        {error}
      </p>
    </div>
  );
};

export const BareError = Error;
export default darkModeAware(Error);
